<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Participants list'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <h2>
            {{'Trainer'|translate}} {{event.groupActivity.trainer.firstName}} {{event.groupActivity.trainer.lastName}}
        </h2>
        <h3>
            {{'Number of contestants'|translate}}: {{event.groupActivity.participants?event.groupActivity.participants.length:'0'}}
        </h3>
        <table class="table" *ngIf="event.groupActivity.participants && event.groupActivity.participants.length>0">
            <thead>
            <tr>
                <th>
                    {{'Participant'|translate}}
                </th>
                <th>
                    {{'Confirmed'|translate}}
                </th>
                <th>
                    {{'Took part in'|translate}}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let participant of event.groupActivity.participants">
                <td><span *ngIf="participant.customer">{{participant.customer.firstName}} {{participant.customer.lastName}}</span></td>
                <td>
                    {{participant.confirmed?('Yes'|translate):('No'|translate)}}
                </td>
                <td>
                    {{participant.tookPartIn?('Yes'|translate):('No'|translate)}}
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Close">
            {{'Close'|translate}}
        </button>

    </div>
</div>
